module.exports = __webpack_public_path__ + "static/media/averta-semibold.d774c54a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta-semibold.woff
// module id = 848
// module chunks = 4